<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('topics.editSupplier')"></page-title>
    </div>

    <jet-form-section @submitted="updateSupplier()">

        <template #form>
            <!-- Card Supplier -->
            <form-card :title="$t('topics.supplier')" :description="$t('topics.supplierDescription')">

                <!-- Volle Breite und Tippfilter wie in den drei Offerten-Modals
                     (`CreateOffer`/`UpdateOffer`/`ReplaceOffer`) — dieses Modal
                     war als einziges auf halber Breite und ohne Filter
                     stehengeblieben. -->
                <div class="col-span-6">
                    <label for="suppliers" class="block text-sm font-medium text-gray-700">{{
                            $t("topics.supplier")
                        }}</label>
                    <div class="mt-1 flex">
                        <Dropdown
                            filter
                            id="suppliers"
                            v-model="form.supplier_uuid"
                            :options="alleUnternehmer"
                            optionValue="uuid"
                            optionLabel="name"
                            :placeholder="$t('suppliers.noSupplier')"
                            :showClear="true"
                            class="w-full" />
                    </div>
                    <jet-input-error :message="form.errors['supplier']" class="mt-2" />

                    <!-- Unternehmer direkt hier anlegen (Entscheid Peter,
                         31.08.2026) — bisher musste man dafür in die
                         Einstellungen wechseln und die Maske verlassen. -->
                    <SupplierCreateInline @created="uebernehmeNeuenUnternehmer" />
                </div>

                <!-- R3 Punkt 4: `v-show` statt `v-if` — s. Docblock
                     `ContactPicker.vue` (Reset-Watcher braucht dauerhaftes
                     Mounten). -->
                <div class="col-span-6" v-show="selectedSupplier">
                    <label class="block text-sm font-medium text-gray-700">{{
                        $t("suppliers.contactPerson")
                    }}</label>
                    <ContactPicker
                        :supplier="selectedSupplier"
                        :value="form.supplier_contact_uuid"
                        @input="form.supplier_contact_uuid = $event"
                    />
                    <jet-input-error
                        :message="form.errors['supplier_contact_uuid']"
                        class="mt-2"
                    />
                </div>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import ContactPicker from "@/Shared/Components/Suppliers/ContactPicker.vue";
import SupplierCreateInline from "@/Shared/Components/Suppliers/SupplierCreateInline.vue";


export default defineComponent({
    props: ["apartment", "topic", "suppliers"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        ContactPicker,
        SupplierCreateInline,
    },
    data() {
        return {
            // Befund H-6: statt die Inertia-Prop `suppliers` per `push()` zu
            // mutieren, fuehrt eine lokale Liste die frisch angelegten
            // Unternehmer — `alleUnternehmer` fuehrt beides zusammen.
            zusaetzlicheUnternehmer: [],
        };
    },
    computed: {
        alleUnternehmer() {
            return [...(this.suppliers || []), ...this.zusaetzlicheUnternehmer];
        },
        selectedSupplier() {
            return this.alleUnternehmer.find((supplier) => supplier.uuid === this.form.supplier_uuid) ?? null;
        }
    },
    // R3 Punkt 4: der Unternehmer-Wechsel-Reset der Kontaktperson wandert in
    // `ContactPicker.vue` — kein eigener Watcher mehr hier.
    methods: {
        /**
         * Der frisch angelegte Unternehmer wird der Auswahlliste hinzugefügt
         * und gleich gewählt — ohne Neuladen, damit alle übrigen Eingaben in
         * dieser Maske erhalten bleiben.
         */
        uebernehmeNeuenUnternehmer(supplier) {
            this.zusaetzlicheUnternehmer.push(supplier);
            this.form.supplier_uuid = supplier.uuid;
            this.form.supplier_contact_uuid = null;
        },
        cancel() {
            this.$emit("closeModal");
        },
        updateSupplier() {
            this.form.put(this.route("advisors.topics.update", { apartment: this.apartment.uuid, topic: this.topic }), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "topics.updated"
                })
            });
        }
    }, setup(props) {
        const form = useForm({
            supplier_uuid: props.topic.supplier_uuid,
            // Thema 9 Paket c: IMMER mitsenden — `UpdateTopicFeature:33-37`
            // unterscheidet `has()` (Schlüssel vorhanden) von fehlendem
            // Schlüssel (Kontakt behalten); ein bedingt weggelassenes Feld
            // würde einen bestehenden Kontakt nie wieder löschbar machen.
            supplier_contact_uuid: props.topic.supplier_contact_uuid
        });

        return { form };
    }
});
</script>

<style scoped></style>
